import { useAppSelector } from "../../services/redux/hooks/use-selector";
import { Main } from "./Components/Main";
import { Placeholder } from "./Components/Placeholder";
import { Sidebar } from "./Components/Sidebar";
import { selectLoading, selectVectors } from "./redux/selectors";
import styles from "./styles.module.css";

export const Embeddings = () => {
  const vectors = useAppSelector(selectVectors);
  const isLoading = useAppSelector(selectLoading);

  return (
    <div className={styles.container}>
      <Sidebar/>
      {
        !vectors && !isLoading ?
          (<Placeholder/>) :
          (<Main vectors={vectors} isLoading={isLoading}/>)
      }
    </div>
  );
};